import apiClient from 'services/axios'
import routeNames from 'routeNames/backendRouteNames'

export default class TicketService {
  constructor() {
    this.apiClient = apiClient
    this.routeNames = routeNames
  }

  getDeskTickets = async ({ id, params }) => {
    let route = this.routeNames.GET_DESK_TICKETS.path
    route = route.replace(':id', id)
    return this.apiClient.get(route, { params })
  }

  getTickets = async ({ params }) => {
    return this.apiClient.get(this.routeNames.GET_TICKETS.path, { params })
  }

  getTicketById = async ({ id, params }) => {
    let route = this.routeNames.GET_TICKET.path
    route = route.replace(':id', id)
    return this.apiClient.get(route, { params })
  }

  createTicket = async ({ body }) => {
    return this.apiClient.post(this.routeNames.CREATE_TICKET.path, body)
  }

  updateTicket = async ({ id, body }) => {
    let route = this.routeNames.GET_TICKET.path
    route = route.replace(':id', id)
    return this.apiClient.put(route, body)
  }

  getComments = async ({ ticketId }) => {
    let route = this.routeNames.GET_COMMENT.path
    route = route.replace(':ticketId', ticketId)
    return this.apiClient.get(route)
  }

  creatComments = async ({ ticketId, body }) => {
    let route = this.routeNames.CREATE_COMMENT.path
    route = route.replace(':ticketId', ticketId)
    return this.apiClient.post(route, body)
  }

  updateStatus = async ({ ticketId, body }) => {
    let route = this.routeNames.UPDATE_TICKET.path
    route = route.replace(':ticketId', ticketId)
    return this.apiClient.patch(route, body)
  }

  approveTicket = async ({ ticketId, approve }) => {
    let route = this.routeNames.APPROVE_TICKET.path
    route = route.replace(':ticketId', ticketId)
    return this.apiClient.patch(route, { approve })
  }

  deleteTicket = async ({ ticketId }) => {
    let route = this.routeNames.DELETE_TICKET.path
    route = route.replace(':ticketId', ticketId)

    return this.apiClient.patch(route)
  }

  deleteComment = async ({ id }) => {
    let route = this.routeNames.DELETE_COMMENT.path
    route = route.replace(':id', id)

    return this.apiClient.patch(route)
  }
}
